import * as Constants from "../../config/constants/Constants.js";
import { getLanguage } from "../../config/language/language.js";

async function fetchFromBackend(url, HTTPmethod, HTTPheaders, HTTPbody) {
    try {
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), Constants.HTTP_QUERY_TIMEOUT_MS);

        const response = await Promise.race([
            fetch(url, {
                method: HTTPmethod,
                headers: HTTPheaders,
                body: typeof HTTPbody === "object" && HTTPbody !== undefined ? JSON.stringify(HTTPbody) : HTTPbody,
                signal: controller.signal,
            }),
            new Promise((_, reject) => setTimeout(() => reject(new Error("Request timed out")), Constants.HTTP_QUERY_TIMEOUT_MS)),
        ]);

        clearTimeout(id);

        const contentType = response.headers.get("Content-Type");
        let data;
        try {
            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            } else if (contentType && (contentType.includes("text/plain") || contentType.includes("text/html"))) {
                data = await response.text();
            } else {
                data = undefined;
            }
        } catch (e) {
            data = undefined;
        }

        return { ok: response.ok, body: data, status: response.status };
    } catch (e) {
        return { ok: false, body: undefined, status: 0 };
    }
}

export const createUrl = (options = {}) => {
    const { ip, port, path } = options;
    const newIp = ip ? window.location.protocol + "//" + ip : Constants.SERVER_IP;
    const newPort = port ? ":" + port : Constants.SERVER_PORT;
    return newIp + newPort + (path ?? "");
};

const createRequestVariables = (path, jwt, options = {}) => {
    const url = createUrl({ ...options, path });
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: jwt ? "Bearer " + jwt : "",
        ...options.headers,
    };
    return { url, headers };
};

export const getFetch = async (path, jwt, options) => {
    const { url, headers } = createRequestVariables(path, jwt, options);
    return fetchFromBackend(url, "GET", headers);
};

export const postFetch = async (path, body, jwt) => {
    const { url, headers } = createRequestVariables(path, jwt);
    return fetchFromBackend(url, "POST", headers, body);
};

export const putFetch = async (path, body, jwt) => {
    const { url, headers } = createRequestVariables(path, jwt);
    return fetchFromBackend(url, "PUT", headers, body);
};

export const deleteFetch = async (path, body, jwt) => {
    const { url, headers } = createRequestVariables(path, jwt);
    return fetchFromBackend(url, "DELETE", headers, body);
};

export const catchAPIResponse = (props, response, options = {}) => {
    const { customColor, customMessage, showMessage = true, onUnauthorized } = options;
    const status = response?.status ?? "UNKN";
    const message = response?.body?.detail?.[0]?.msg || response?.body?.detail || customMessage || getLanguage().SNACKBAR_ERROR_RESPONSE;
    const color = customColor ?? "error";

    console.warn("Non-successful status code:", response);

    try {
        if (showMessage) props.showSnackbar({ color, duration: 6000, message: `Error (${status}): ${message}` });
        if (response.status === 401 && onUnauthorized) onUnauthorized();
    } catch (e) {
        console.warn(e);
    }
};

export const catchAPIError = (props, err, options = {}) => {
    const { customMessage, showMessage = true } = options;
    console.error("API error:", err);
    if (!showMessage) return;
    const message = customMessage ?? getLanguage().SNACKBAR_ERROR_SERVER;
    try {
        props.showSnackbar({ color: "error", duration: 6000, message });
    } catch (e) {
        console.error(e);
    }
};
